import { ServiceDto } from './service.dto'

export enum BannerStatus {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED'
}
export interface BannerDto {
  id: string

  bannerStatus: BannerStatus

  bannerImage: string
  bannerImageUrl: string

  serviceId: string

  service?: ServiceDto
  order: number
}

export interface ListBannerResponseDto {
  items: BannerDto[]

  count: number
}

export interface CreateNewBannerRequestBodyDto {
  bannerStatus: BannerStatus
  bannerImage: string
  serviceId: string | undefined
}

export interface UpdateBannerRequestBodyDto {
  bannerStatus: BannerStatus

  bannerImage: string

  bannerImageIsTemporary?: boolean

  serviceId: string | undefined

  order?: number
}

export interface UpdateBannerOrderDto {
  items: {
    id: string;
    order: number
  }[]
}